import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sort: "",
  isSaved: false,
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    sortedBy: (state, action) => {
      state.sort = action.payload;
    },
    filteredSaved: (state, action) => {
      state.isSaved = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { sortedBy, filteredSaved } = filterSlice.actions;
